import React from 'react';
import clsx from 'classnames';
import { css } from '@emotion/css';

/**
 * Two-column grid for the header fields of a full-page form (écriture, facture,
 * avoir, encaissement, dépense…).
 *
 * The header used to be a single 450px-wide vertical Stack with 18px gaps: five
 * short fields stacked down the left edge while the whole right half of the
 * page stayed empty, and the block was taller than the entries grid below it.
 * Laying the same fields out in two columns with tighter rows fills the width,
 * halves the header height, and keeps the big amount on the right where it was.
 *
 * Collapses back to one column on narrow viewports (the app is ≥1100px, but the
 * header shares its row with the amount, so the fields area can still get thin).
 */
export const pageFormHeaderFieldsGrid = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 400px));
  gap: 10px 44px;
  align-content: start;
  flex: 1;
  min-width: 0;

  /* Keep a wrapped label (« Date de comptabilisation ») from inflating its row. */
  .bp4-label {
    line-height: 1.25;
  }

  @media (max-width: 1200px) {
    grid-template-columns: minmax(0, 420px);
  }
`;

export interface PageFormHeaderFieldsProps {
  className?: string;
  children?: React.ReactNode;
}

export function PageFormHeaderFields({
  className,
  children,
}: PageFormHeaderFieldsProps) {
  return (
    <div className={clsx(pageFormHeaderFieldsGrid, className)}>{children}</div>
  );
}
